import camelCase from 'lodash/camelCase';
import { useTranslation } from 'next-i18next';
import { getShortInformation as formatTravelRooms } from '@hotelplan/components.common.travel-rooms';
import { getShortInformation as formatTravelDates } from '@hotelplan/fdr.regular.fusion.fdr-travel-dates';
import { getShortInformation as formatTravelDestinations } from 'fdr/components/candidate/fdr-search-control/destination/fdr-destination-field.util';
import { TFdrProductSrlControlStateWithType } from 'fdr/components/candidate/fdr-search/types/search-form.types';

export enum CurrentSearchFieldTypes {
  dates = 'TravelDates',
  rooms = 'TravelRooms',
  destination = 'TravelDestination',
}

export const useFdrCurrentSearch = (
  searchControl: TFdrProductSrlControlStateWithType | null,
  fieldTypes?: CurrentSearchFieldTypes[]
) => {
  const [t] = useTranslation(['common', 'search']);

  if (!searchControl) return [];

  const {
    legacy_travelDestination = null,
    travelDates = null,
    travelRooms = null,
  } = searchControl;

  const formattedTravelDestination =
    legacy_travelDestination &&
    formatTravelDestinations(t, legacy_travelDestination.destinations || []);

  const formattedTravelDates =
    travelDates &&
    formatTravelDates(t, {
      departureDate: travelDates.departureDate,
      returnDate: travelDates.returnDate,
      durationData: travelDates.duration,
      showDuration: true,
    }).travelDates;

  const formattedTravelRooms = travelRooms && formatTravelRooms(t, travelRooms);

  const formattedValues = {
    [CurrentSearchFieldTypes.dates]: formattedTravelDates,
    [CurrentSearchFieldTypes.rooms]: formattedTravelRooms,
    [CurrentSearchFieldTypes.destination]: formattedTravelDestination,
  };

  return !fieldTypes
    ? [
        { testId: 'travelDestination', content: formattedTravelDestination },
        { testId: 'travelDates', content: formattedTravelDates },
        { testId: 'travelRooms', content: formattedTravelRooms },
      ]
    : fieldTypes.map(field => {
        return {
          testId: camelCase(field),
          content: formattedValues[field],
        };
      });
};
